import { Button } from '@mui/material';
import { AlertDialog } from 'src/components';
import { AlertDialogDeleteAlarmRuleContentContent } from '../AlertDialogContent';
import { CANCEL_ACTION_NAME, DELETE_ACTION_NAME, DELETE_ALARM_RULE } from '../../config';

type AlertDialogDeleteAlarmRuleProps = {
  AlarmRuleDeleteToggleState: boolean;
  onDeleteAlarmRuleToggle: () => void;
  handleDelete: any;
  title: string;
  dialogTitle?: string;
  isAlarmRule: boolean;
};

export const AlertDialogDeleteAlarmRule = ({
  AlarmRuleDeleteToggleState,
  onDeleteAlarmRuleToggle,
  handleDelete,
  title,
  dialogTitle = DELETE_ALARM_RULE,
  isAlarmRule,
}: AlertDialogDeleteAlarmRuleProps) => (
  <>
    <AlertDialog
      maxWidth="md"
      testId="delete-alarm-rule-modal"
      open={AlarmRuleDeleteToggleState}
      onClose={onDeleteAlarmRuleToggle}
      title={dialogTitle}
      customContent={
        <AlertDialogDeleteAlarmRuleContentContent
          deleteAlarmRule={{ onDelete: handleDelete, title: title }}
          isAlarmRule={isAlarmRule}
        />
      }
      action={
        <>
          <Button
            variant="outlined"
            color="primary"
            onClick={onDeleteAlarmRuleToggle}
            data-sm="cancel-button"
          >
            {CANCEL_ACTION_NAME}
          </Button>
          <Button
            variant="contained"
            color="primary"
            data-sm="delete-button"
            onClick={handleDelete}
          >
            {DELETE_ACTION_NAME}
          </Button>
        </>
      }
    />
  </>
);
